import Axios from "axios";
import {
  ApiBaseUrl,
  BasicInformationBaseUrl,
  LoanBaseUrl,
} from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  GetBanksResponse,
  GetCitiesRequest,
  GetCitiesResponse,
  GetLoanTemplateRequiredAttachmentsTypeForSupplierRequest,
  GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse,
  GetStatusResponse,
} from "../models/basicInformation.model";
import { GetLoanTemplatesForSetadResponse } from "../models/loan.model";
import { GetEnumsResponse } from "../models/enum.model";

export const getLoanRequestStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanRequestStatus"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanTemplatesForSetad = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanTemplatesForSetad"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanTemplatesForApp = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanTemplatesForApp"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetLoanRequestStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanRequestStatus"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetChequeTypeStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetChequeType"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetRegistrationStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetRegistrationStatus"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierSettlementStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetSupplierSettlementStatus"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetLoanRequestSources = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanRequestSources"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierUsers = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetSupplierUsers"
  ).then((result) => {
    return result.data.data;
  });
};

export const getLoanTemplateRequiredAttachmentsTypeForSupplier = (
  data: GetLoanTemplateRequiredAttachmentsTypeForSupplierRequest
): Promise<GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse[]> => {
  return Axios.post<
    ApiResultModel<GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse[]>
  >(
    ApiBaseUrl +
      BasicInformationBaseUrl +
      "/GetLoanTemplateRequiredAttachmentsTypeForSupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSuppliers = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetSuppliers"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetCities = async (
  data: GetCitiesRequest
): Promise<GetCitiesResponse[]> => {
  return await Axios.post<ApiResultModel<GetCitiesResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + BasicInformationBaseUrl + "/GetCities",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetBanks = async (): Promise<GetBanksResponse[]> => {
  return await Axios.get<ApiResultModel<GetBanksResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetBanks"
  ).then((result) => {
    return result.data.data;
  });
};
